<template>
    <div class="d-flex align-items-start" :class="wrapperClass">
        <input
            :id="checkboxId"
            type="checkbox"
            class="mr-1 mt-1"
            :value="value"
            :checked="value"
            :disabled="disabled"
            @change="handleChange"
        />
        <label
            :for="checkboxId"
            class="font-weight-normal m-0"
            :class="labelClass"
        >
            Apply item rule
        </label>
    </div>
</template>

<script>
export default {
    name: "ApplyItemRuleCheckbox",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        wrapperClass: {
            type: String,
            default: ""
        },
        labelClass: {
            type: String,
            default: ""
        },
        checkboxId: {
            type: String,
            default() {
                return `apply-item-rule-${Math.random()
                    .toString(36)
                    .substr(2, 9)}`;
            }
        }
    },
    watch: {
        value(newValue) {
            this.$emit("input", newValue);
        }
    },
    methods: {
        handleChange(event) {
            const checked = event.target.checked;
            this.$emit("input", checked);
            this.$emit("change", checked);
        }
    }
};
</script>
